import { Machine } from 'xstate'

export const authMachine = Machine({
  key: 'auth',
  initial: 'loggedOut',
  states: {
    loggedOut: {
      on: {
        LOGIN: 'loggingIn',
        FORGOT_PASSWORD: 'forgotPassword',
        FORGOT_EMAIL: 'forgotEmail',
        IS_AUTHENTICATED: 'loggedIn'
      }
    },
    loggingIn: {
      onEntry: ['loginProcess'],
      on: {
        SUCCESS: 'loggedIn',
        FAILURE: 'loggedOut'
      }
    },
    loggedIn: {
      on: {
        LOGOUT: 'loggedOut'
      }
    },
    forgotPassword: {
      on: {
        BACK: 'loggedOut',
        FORGOT_EMAIL: 'forgotEmail'
      }
    },
    forgotEmail: {
      on: {
        BACK: 'loggedOut'
      }
    }
  }
})
